import React from 'react';
import { MainProvider } from './MainContext';
import { FileTypeProvider } from './Management/FileTypeContext';
import { JobProvider } from './Management/JobContext';
import { EmailTemplateProvider } from './Management/EmailTemplateContext';
import { EmailLogProvider } from './Management/EmailLogContext';
import { LanguageProvider } from './LanguageContext';
import { MailSettingsProvider } from './Management/MailSettingsContext';
import { UsersProvider } from './Management/UsersContext';
import { BetterStandsProvider } from './Management/BetterStandsContext';
import { FairProvider } from './Management/FairContext';
import {SahaFormProvider} from "./Management/SahaFormContext";
// #311: firma portalının bağlamı (MainContext'in seçili fuarını okur, o yüzden onun içinde).
import { PortalProvider } from './PortalContext';
// #540: the consent gate's state (reads the portal context, so it sits inside PortalProvider).
import { OnayProvider } from './OnayContext';

const AppProvider = ({ children }) => (
    <MainProvider>
        <FileTypeProvider>
            <JobProvider>
                <EmailTemplateProvider>
                    <EmailLogProvider>
                        <MailSettingsProvider>
                            <UsersProvider>
                                <BetterStandsProvider>
                                    <SahaFormProvider>
                                        <FairProvider>
                                            <LanguageProvider>
                                                <PortalProvider>
                                                    <OnayProvider>
                                                        {children}
                                                    </OnayProvider>
                                                </PortalProvider>
                                            </LanguageProvider>
                                        </FairProvider>
                                    </SahaFormProvider>
                                </BetterStandsProvider>
                            </UsersProvider>
                        </MailSettingsProvider>
                    </EmailLogProvider>
                </EmailTemplateProvider>
            </JobProvider>
        </FileTypeProvider>
    </MainProvider>
);

export default AppProvider;
